export const EXCLUDED_CLIENT_ID = "13e29ea2-d549-4387-8171-f063f9cfd294";
